import React, {useState} from "react";
import {NavLink} from "react-router-dom";
export default function Categorys() {
  const [openCat, setOpenCat]= useState("");
  const filters = [
    {key:"cuisine", list:["African", "American", "British", "Cajun", "Caribbean","Chinese","Eastern European", "European","French", "German","Greek","Indian", "Italian","Irish", "Japanese","Korean","Latin American","Mediterranean","Middle Eastern","Mexican","Nordic","Southern", "Spanish","Thai", "Vietnamese"]},
    {key:"meal" , list:["main course", "side dish","dessert", "appetizer","salad", "bread", "breakfast","soup", "beverage","sauce", "marinade", "fingerfood", "snack", "drink"]},
    {key:"ingredient" ,list:["Chicken", "Cheese", "Chocolate","Fish", "Lamb","Seafood", "Turkey","Cocktails", "Cookies", "Ice Cream"]},
  ]


  return (
    
    <>

    <nav className="center cats ">
      {filters.map((cat, index)=>(
       
        
        <div className={`cat ${openCat === cat.key ? "open": ""}`} onClick={()=>setOpenCat(openCat=== cat.key ? "":cat.key )} key={index} >
          <h4 >{cat.key}s</h4>
          <div className="filter">
          {cat.list.map((el, index)=>(
            <NavLink className="s-cat" key={index} to={`/explore/${cat.key}=${el}`}>{el}</NavLink>
          
          ))}
          </div>
        </div> 
       
     
      ))}
      </nav>
      
     
    
  
    
    </>
  );
}
